let pendingKnowledgeBaseFiles = [];

export const setPendingKnowledgeBaseFiles = (files) => {
  pendingKnowledgeBaseFiles = Array.isArray(files) ? Array.from(files) : [];
};

export const takePendingKnowledgeBaseFiles = () => {
  const files = pendingKnowledgeBaseFiles;
  pendingKnowledgeBaseFiles = [];
  return files;
};

export const peekPendingKnowledgeBaseFiles = () => pendingKnowledgeBaseFiles;

export const clearPendingKnowledgeBaseFiles = () => {
  pendingKnowledgeBaseFiles = [];
};
